import { http } from '../util/http'
import { API_KOTLIN_DOMAIN } from '../config'
import headers from './employeeSystemHeader'

// 获取业务分组列表
export const fetchProfessionList = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/firmType`,
  })
}

// 新增业务分组
export const addProfession = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/firmType/add`,
    method: 'post',
    data,
  })
}

// 修改业务分组
export const modifyProfession = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/firmType/edit`,
    method: 'post',
    data,
  })
}

// 删除业务分组
export const removeProfession = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/firmType/delete`,
    method: 'post',
    data,
  })
}

// 桌台详情
export const fetchTableDetail = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/table/detail`,
    params,
  })
}

// 新建或修改桌台
export const postTableDetail = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/table`,
    method: 'post',
    data,
  })
}

// 获取业务分组列表
export const fetchClubTableType = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/firmType`,
    params,
  })
}



// WEBPACK FOOTER //
// ./src/api/clubProfession.js